import { trimUrlPath } from "../../utils/url";

export const prepareUrl = (path: string) => {
  const trimmedPath = trimUrlPath(path);
  return trimmedPath !== "" && trimmedPath !== "file-not-found"
    ? trimmedPath
    : "default";
};
